<template>
  <div>
    <main class="home">
      <carousel></carousel>
      <div class="play-btn">
        <div :class="['games-left', userDetails.availableGames == 0 ? 'games-left--zero' : '']">
          <span class="games-left__num">{{ numberFormatting(userDetails.availableGames) }}</span>
          <span class="games-left__text">{{ getTranslations.home_default_content_games }} <br> {{ getTranslations.home_default_content_games_left_text }} </span>
        </div>
        <div class="home-playbtn" @click="playGame" style="cursor:pointer"><a><h1>{{ getTranslations.home_profile_default_content_new_game }}</h1></a></div>
      </div>
      <div class="center mb-5 mt-5" v-if="!hideStore" @click.prevent="toStorePage"  style="cursor:pointer">
        <a class="btn btn--medium btn--main ">{{ getTranslations.home_buy_games }}</a>
      </div>

      <section class="game-history" v-if="getShowHistory">
        <div class="game-history-list">
            <h2>{{ getTranslations.home_default_content_games_history }}</h2>

          <div v-for="(playedGame, index) in orderedGames" :key="index" :class="['list-item', playedGame.winner ? 'win' : 'loose']">
            <div class="list-item__avatar"><img :src="playedGame.avatar" alt=""></div>
            <div class="list-item__info">
              <span class="list-item__info__name">{{ playedGame.opponentName }}</span>
              <span class="list-item__info__result">{{ playedGame.winner ? getTranslations.home_default_content_won : getTranslations.home_default_content_lost }}</span>
              <span class="list-item__info__when">{{ playedGame.timestamp | getMoment }}</span>
            </div>
            <div v-if="playedGame.home" class="list-item__score" @click="matchInfo(playedGame)" style="cursor:pointer">{{ playedGame.playerScore }}-{{ playedGame.opponentScore }}</div>
            <div v-if="!playedGame.home" class="list-item__score" @click="matchInfo(playedGame)" style="cursor:pointer">{{ playedGame.opponentScore }}-{{ playedGame.playerScore }}</div>
          </div>
        </div>
      </section>
        <section class="game-history" v-else>
        <div class="game-history-list home_empty">

          <h2>{{ getTranslations.home_default_content_games_history }}</h2>

          <div class="game-history-list-empty-img-holder">

            <img :src="getTranslations.project_home_empty_img" alt="">
          </div>
          <h2>{{ getTranslations.home_no_game_history }}</h2>
            <p class="list-item__info__when">{{ getTranslations.home_no_game_history_text1 }}
            <br>{{ getTranslations.home_no_game_history_text2 }}</p>
        </div>
      </section>
    </main>
    <div class="bonus_phase_outer" v-if="showOptOutPhase">
      <div class="bonus_phase promo_phase_fp" id="optout">
        <div class="bonus_phase_inner ">
          <div class="promo_phase_outer">
            <div class="bonus_phase_content promo_phase_fp">
              <p> {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'home_page_optout_banner_message') }} <a class="optout__link" @click.prevent="goToEditProfile">{{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'home_page_optout_banner_click_here') }}</a></p>
            </div>
          </div>
        </div>
        <button class="bonusclose"  id="bonusclose" @click="closeBannerForOptout()"></button>
      </div>
    </div>
    <!-- dynamically change modals -->
    <component :is="currentModal"></component>
  </div>
</template>

<script>
  /* eslint no-console: "off" */
import { mapGetters, mapActions, mapState } from 'vuex';
import Vue from 'vue';
import { closeBanner } from '@/common/jQuery';
import NumbersFormattingMixin from '@/common/mixins/numbersFormatting';
import Carousel from './Carousel';
import ScoreDescription from './modals/ScoreDescription';


const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'default-content',
  props: ['playGame'],
  components: {
    Carousel,
    ScoreDescription,
  },
  mixins: [NumbersFormattingMixin],
  data() {
    return {
      currentModal: null,
    };
  },
  created() {
    this.showModal();
    moment.locale(this.getLocale.toLowerCase());
  },
  mounted() {
    closeBanner();
  },
  methods: {
    ...mapActions('profile', [
      'setMatchInfo',
    ]),
    goToEditProfile() {
      this.$router.push({ name: 'settings' });
    },
    toStorePage() {
      this.$router.push('/home/store');
    },
    closeBannerForOptout() {
      closeBanner();
    },
    matchInfo(playedGame) {
      this.setMatchInfo(playedGame).then(() => {
        this.currentModal = ScoreDescription;
        this.showModal();
      });
    },
    showModal() {
      /* eslint-disable */
      const vm = this;
      this.$nextTick(() => {
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(function () {
          $('.modal, .modal-overlay').fadeOut();
          if(vm.currentModal != null) {
            vm.currentModal = null;
            vm.showModal();
          }
        });
      });
      /* eslint-enable */
    },
  },
  computed: {
    ...mapState('common', [
      'hideStore',
      'userDetails',
      'showOptOutPhase',
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
    ...mapGetters('profile', [
      'getGameHistoryData',
      'getShowHistory',
    ]),
    orderedGames() {
      // sort games by date ascending
      return this.getGameHistoryData.slice(0).sort((a, b) => b.timestamp - a.timestamp);
    },
  },
  filters: {
    getMoment(date) {
      return moment(date).fromNow();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/DefaultContent.vue